import { SET_PROPERTY_FIELDS } from '../../../types';
import { updateNetApprovedValue, updateValueGrossBook } from '../properties';

export const FDIC_UpdateValuation = (event) => async(dispatch, getState) => {
    try {
        const {
            MISC: { APP: { CODE } },
            properties: { propertyFields, propertyData: { groups } }
        } = getState();
        const { name, value } = event.target;
        let group = groups.find((group) => {
            return group.code === propertyFields.group_code;
        });
        let newPropertyFields = {
            ...propertyFields,
            [name]: value
        };
        switch (name) {
            case 'participation_log': {
                const log = JSON.parse(value);

                if (log.length === 0) {
                    newPropertyFields = {
                        ...newPropertyFields,
                        participation: 'N',
                        participation_percentage_owned: 0,
                        participation_number_of_participants: 0,
                        participation_lead_participant: ''
                    };
                }
                else {
                    const percentOwned = log.reduce((decumulate, value) => decumulate - value.Percentage, 100);
                    const leadParticipant = log.shift();
                    let leadParticipantName = CODE + " as receiver for " + group.name;

                    if(percentOwned < leadParticipant.Percentage) {
                        leadParticipantName = leadParticipant.Participant;
                    }

                    newPropertyFields = {
                        ...newPropertyFields,
                        participation: 'Y',
                        participation_percentage_owned: percentOwned,
                        participation_number_of_participants: log.length,
                        participation_lead_participant: leadParticipantName
                    };
                }
            }
            default:
                break;
        }
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        throw new Error('Valuation: ' + error.message);
    }
    finally {
        //	POST UPDATE
        switch (name) {
            case 'value_gross_approved':
                dispatch(updateNetApprovedValue());
                break;
            case 'value_gross_book':
                dispatch(updateValueGrossBook());
                break;
            case 'participation_log':
                await dispatch(updateNetApprovedValue());
                dispatch(updateValueGrossBook());
                break;
            default:
                break;
        }
    }
};
